<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import VoiceCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/VoiceCampaign/VoiceCampaignForm.vue';

const emit = defineEmits(['close', 'created']);

const store = useStore();
const { t } = useI18n();

const dialogRef = ref(null);

const handleSubmit = async campaignDetails => {
  try {
    const campaign = await store.dispatch('campaigns/create', campaignDetails);
    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.VOICE_DIALER,
    });
    useAlert(t('CAMPAIGN.VOICE.CREATE.FORM.API.SUCCESS_MESSAGE'));
    emit('created', campaign);
  } catch (error) {
    useAlert(
      error?.response?.message ||
        t('CAMPAIGN.VOICE.CREATE.FORM.API.ERROR_MESSAGE')
    );
  }
};

const handleFormCancel = () => dialogRef.value?.close();
const handleDialogClose = () => emit('close');

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CAMPAIGN.VOICE.CREATE.TITLE')"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="handleDialogClose"
  >
    <VoiceCampaignForm @submit="handleSubmit" @cancel="handleFormCancel" />
  </Dialog>
</template>
